import { pathSpecificCanonicalsMap } from './constants'

export const getCanonical = (path = '', param = '') => {
  if (!path) {
    return 'https://recovery.com'
  }

  const pathSpecificCanonical = pathSpecificCanonicalsMap[path]

  if (pathSpecificCanonical) {
    return `https://recovery.com${pathSpecificCanonical}`
  }

  const defaultCanonical = `https://recovery.com${path.replace(/\*$/, param)}`

  return defaultCanonical.endsWith('/')
    ? defaultCanonical
    : defaultCanonical + '/'
}
